import React, { Component, Fragment } from 'react';
import { Map, Marker, CircleMarker, Popup, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import Moment from 'react-moment';

const markerEnd = new L.Icon({
  iconUrl:        '/assets/images/marker-home.png',
  iconRetinaUrl:  '/assets/images/marker-home.png',
  iconSize:       [32, 32], // size of the icon
  iconAnchor:     [16, 32],
  popupAnchor:    [0, -33]
});

const markerStart = new L.Icon({
  iconUrl:        '/assets/images/marker-store.png',
  iconRetinaUrl:  '/assets/images/marker-store.png',
  iconSize:       [32, 32], // size of the icon
  iconAnchor:     [16, 32],
  popupAnchor:    [0, -33]
});

export default class AxlMap extends Component {
  state = {
    zoom: 10
  };

  render() {
    const { tracking } = this.props
    var bounds = tracking && tracking.length > 1 ? tracking.map(t => [t.geolocation.latitude, t.geolocation.longitude]) : [];
    if (this.props.start) {
      bounds.push([this.props.start.latitude, this.props.start.longitude])
    }
    if (this.props.end) {
      bounds.push([this.props.end.latitude, this.props.end.longitude])
    }
    var current = tracking && tracking.length > 0 ? tracking[tracking.length - 1] : null;

    return <Map zoom={this.state.zoom} bounds={bounds}>
        <TileLayer
          attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> &copy; <a href='https://carto.com/attributions'>CARTO</a>"
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        { this.props.start && <Marker icon={markerStart} position={[this.props.start.latitude, this.props.start.longitude]}>
          <Popup>
            <div>{this.props.start.street}</div>
            <div>{this.props.start.street2}</div>
            <div>{this.props.start.city}</div>
            <div>{this.props.start.state} {this.props.start.zipcode}</div>
          </Popup>
        </Marker> }
        { tracking && tracking.map((e, index) => <CircleMarker color={ e.event_type === 'dropoff' ? '#22f' : (e.event_type === 'return' ? '#f22' : '#555')} key={index} weight={1} radius={4} center={[e.geolocation.latitude, e.geolocation.longitude]}>
        </CircleMarker>)}
        {!this.props.complete && current && <Fragment>
          <CircleMarker weight={0} radius={12} fillOpacity={0.4} center={[current.geolocation.latitude, current.geolocation.longitude]}></CircleMarker>
          <CircleMarker weight={1} opacity={1} fillOpacity={1} radius={5} center={[current.geolocation.latitude, current.geolocation.longitude]}>
            <Popup>
              <div>ETA: <Moment format="hh:mm A">{ current.eta + current.ts }</Moment></div>
            </Popup>
          </CircleMarker>
        </Fragment> }
        { this.props.end && <Marker icon={markerEnd} position={[this.props.end.latitude, this.props.end.longitude]}>
          <Popup>
            <div>{this.props.end.street}</div>
            <div>{this.props.end.street2}</div>
            <div>{this.props.end.city}</div>
            <div>{this.props.end.state} {this.props.end.zipcode}</div>
          </Popup>
        </Marker> }
      </Map>
  }
}